/* ============================================================================
   MYTHIC NUTRITION — theme.js  (shared foundation interactivity)
   Ported from the static mock's theme.js. The mobile mega-nav drawer lives in
   sections/header.liquid's {% javascript %} block, not here.
   ============================================================================ */

// Countdown timers (PDP urgency + homepage weekly-deal rail) — visual only
(function () {
  var h = document.getElementById('cd-h'),
      m = document.getElementById('cd-m'),
      s = document.getElementById('cd-s');
  if (!h) return;
  var t = (+h.textContent) * 3600 + (+m.textContent) * 60 + (+s.textContent);
  var pad = function (n) { return String(n).padStart(2, '0'); };
  setInterval(function () {
    t = t > 0 ? t - 1 : 0;
    h.textContent = pad(Math.floor(t / 3600));
    m.textContent = pad(Math.floor((t % 3600) / 60));
    s.textContent = pad(t % 60);
  }, 1000);
})();

// Quantity steppers (PDP + quick-view) — keeps a hidden form field in sync
document.querySelectorAll('.qty').forEach(function (q) {
  var input = q.querySelector('input:not([type=hidden])');
  var btns = q.querySelectorAll('button');
  if (!input || btns.length < 2) return;
  var sync = function () {
    var mirror = q.closest('form') && q.closest('form').querySelector('[data-qty-mirror]');
    if (mirror) mirror.value = input.value;
  };
  btns[0].addEventListener('click', function (e) { e.preventDefault(); input.value = Math.max(1, (+input.value || 1) - 1); sync(); });
  btns[1].addEventListener('click', function (e) { e.preventDefault(); input.value = (+input.value || 1) + 1; sync(); });
  input.addEventListener('change', sync);
});

// PDP gallery: click a thumbnail to swap the main stage image
document.querySelectorAll('[data-thumb]').forEach(function (t) {
  t.addEventListener('click', function () {
    document.querySelectorAll('[data-thumb]').forEach(function (x) { x.classList.remove('is-active'); });
    t.classList.add('is-active');
    var stage = document.getElementById('stage-img');
    if (stage && t.dataset.src) stage.src = t.dataset.src;
  });
});

// Cart line: auto-submit quantity changes (input sits in a GET form to /cart/change)
document.querySelectorAll('[data-cart-qty]').forEach(function (input) {
  input.addEventListener('change', function () { input.closest('form').submit(); });
});

// Language / market switcher — UI shell around the native localization form.
// Picking a language submits the form; the translated copy itself comes from
// Shopify Markets + a translation app, not the theme.
(function () {
  var el = document.querySelector('[data-lang-switch]');
  if (!el) return;
  var toggleBtn = el.querySelector('[data-lang-toggle]');
  var closeBtn  = el.querySelector('[data-lang-close]');
  var scrim     = el.querySelector('[data-lang-scrim]');

  var open  = function () { el.setAttribute('data-open', ''); toggleBtn.setAttribute('aria-expanded', 'true'); };
  var close = function () { el.removeAttribute('data-open'); toggleBtn.setAttribute('aria-expanded', 'false'); };

  toggleBtn.addEventListener('click', function () {
    el.hasAttribute('data-open') ? close() : open();
  });
  closeBtn && closeBtn.addEventListener('click', close);
  scrim && scrim.addEventListener('click', close);

  el.querySelectorAll('[data-lang-radio]').forEach(function (radio) {
    radio.addEventListener('change', function () {
      var form = radio.closest('form');
      var target = form && form.querySelector('[data-lang-input]');
      if (target) target.value = radio.value;
      close();
      if (form) form.submit();
    });
  });
})();

// Cart drawer (mini-cart) — opens after add-to-cart (?added=1, set via the
// product form's return_to) or via the header cart button; "View cart" inside
// it still links to the full page.
(function () {
  var drawer = document.querySelector('[data-cart-drawer]');
  var scrim  = document.querySelector('[data-cart-scrim]');
  if (!drawer || !scrim) return;

  var open = function () { drawer.classList.add('is-open'); scrim.classList.add('is-open'); drawer.setAttribute('aria-hidden', 'false'); };
  var close = function () { drawer.classList.remove('is-open'); scrim.classList.remove('is-open'); drawer.setAttribute('aria-hidden', 'true'); };

  document.querySelectorAll('[data-cart-open]').forEach(function (btn) { btn.addEventListener('click', open); });
  document.querySelectorAll('[data-cart-close]').forEach(function (btn) { btn.addEventListener('click', close); });
  scrim.addEventListener('click', close);

  // Auto-open once, then scrub ?added=1 from the URL so a refresh won't reopen it
  if (new URLSearchParams(window.location.search).has('added')) {
    open();
    var url = new URL(window.location.href);
    url.searchParams.delete('added');
    window.history.replaceState({}, '', url.pathname + (url.search ? url.search : '') + url.hash);
  }
})();

// Quick-view "choose options" modal — opened from a card's quick-add button.
// Each product card carries its own JSON blob (script[data-qv-data]) with real
// variant data; picking options resolves a variant id for /cart/add.
(function () {
  var modal = document.querySelector('[data-qv-modal]');
  var scrim = document.querySelector('[data-qv-scrim]');
  if (!modal || !scrim) return;

  var state = { product: null, imgIndex: 0, selected: [] };

  var img       = modal.querySelector('[data-qv-image]');
  var dots      = modal.querySelector('[data-qv-dots]');
  var title     = modal.querySelector('[data-qv-title]');
  var starsEl   = modal.querySelector('[data-qv-stars]');
  var ratingEl  = modal.querySelector('[data-qv-rating]');
  var reviewsEl = modal.querySelector('[data-qv-reviews]');
  var ratingWrap = modal.querySelector('[data-qv-rating-wrap]');
  var priceEl   = modal.querySelector('[data-qv-price]');
  var opt1Wrap  = modal.querySelector('[data-qv-sizes-wrap]');
  var opt1Label = modal.querySelector('[data-qv-sizes-label]');
  var opt1El    = modal.querySelector('[data-qv-sizes]');
  var opt2Wrap  = modal.querySelector('[data-qv-flavors-wrap]');
  var opt2Label = modal.querySelector('[data-qv-flavors-label]');
  var opt2Sel   = modal.querySelector('[data-qv-flavor-select]');
  var idInput   = modal.querySelector('[data-qv-id-input]');
  var returnInput = modal.querySelector('[data-qv-return]');
  var submitBtn = modal.querySelector('[data-qv-submit]');

  function starSvg(filled) {
    return '<svg viewBox="0 0 24 24" fill="' + (filled ? 'currentColor' : 'none') + '" stroke="currentColor" stroke-width="1.5"><path d="M12 2l3 6.3 6.9 1-5 4.9 1.2 6.8L12 17.8 5.9 21l1.2-6.8-5-4.9 6.9-1z"/></svg>';
  }

  function matchedVariant() {
    var p = state.product;
    if (!p.options.length) return p.variants[0] || null;
    if (state.selected.some(function (v) { return !v; })) return null;
    return p.variants.find(function (variant) {
      return state.selected.every(function (val, i) { return variant.options[i] === val; });
    }) || null;
  }

  function updateSubmitState() {
    var v = matchedVariant();
    if (!v) {
      submitBtn.disabled = true;
      submitBtn.textContent = modal.dataset.strChoose || 'Choose an option first';
    } else if (!v.available) {
      submitBtn.disabled = true;
      submitBtn.textContent = modal.dataset.strSold || 'Sold out';
    } else {
      submitBtn.disabled = false;
      submitBtn.textContent = modal.dataset.strAdd || 'Add to cart';
      idInput.value = v.id;
    }
    if (v) priceEl.textContent = v.price;
  }

  function renderImage() {
    if (!state.product.images.length) return;
    img.src = state.product.images[state.imgIndex];
    dots.querySelectorAll('span').forEach(function (d, i) { d.classList.toggle('is-active', i === state.imgIndex); });
  }

  function open(p) {
    state.product = p;
    state.imgIndex = 0;
    // Pre-select any option with a single value; leave multi-value options open
    state.selected = p.options.map(function (o) { return o.values.length === 1 ? o.values[0] : null; });

    title.textContent = p.title;
    if (p.rating) {
      ratingWrap.style.display = '';
      starsEl.innerHTML = [0, 1, 2, 3, 4].map(function (i) { return starSvg(i < Math.round(p.rating)); }).join('');
      ratingEl.textContent = (+p.rating).toFixed(1);
      reviewsEl.textContent = p.reviews || '';
    } else {
      ratingWrap.style.display = 'none';
    }
    priceEl.textContent = p.price;
    var qtyInput = modal.querySelector('[data-qv-qty-input]');
    var qtyMirror = modal.querySelector('[data-qty-mirror]');
    if (qtyInput) qtyInput.value = 1;
    if (qtyMirror) qtyMirror.value = 1;
    if (returnInput) returnInput.value = window.location.pathname + (window.location.search ? window.location.search + '&' : '?') + 'added=1';

    dots.innerHTML = p.images.map(function () { return '<span></span>'; }).join('');
    renderImage();

    var o1 = p.options[0], o2 = p.options[1];
    opt1Wrap.style.display = o1 && o1.values.length > 1 ? '' : 'none';
    if (o1) {
      opt1Label.textContent = o1.name;
      opt1El.innerHTML = o1.values.map(function (v) {
        return '<button type="button" class="variant-opt' + (v === state.selected[0] ? ' is-selected' : '') + '" data-qv-opt1="' + v.replace(/"/g, '&quot;') + '">' + v + '</button>';
      }).join('');
    } else {
      opt1El.innerHTML = '';
    }

    opt2Wrap.style.display = o2 && o2.values.length > 1 ? '' : 'none';
    if (o2) {
      opt2Label.textContent = o2.name;
      opt2Sel.innerHTML = '<option value="">Choose an option…</option>' + o2.values.map(function (v) {
        return '<option value="' + v.replace(/"/g, '&quot;') + '"' + (v === state.selected[1] ? ' selected' : '') + '>' + v + '</option>';
      }).join('');
    }

    updateSubmitState();
    scrim.classList.add('is-open');
    if (typeof modal.showModal === 'function') modal.showModal(); else modal.setAttribute('open', '');
  }

  function close() {
    scrim.classList.remove('is-open');
    if (typeof modal.close === 'function') modal.close(); else modal.removeAttribute('open');
  }

  document.querySelectorAll('[data-quickadd]').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      var card = btn.closest('.card');
      var dataEl = card && card.querySelector('[data-qv-data]');
      if (!dataEl) return;
      try { open(JSON.parse(dataEl.textContent)); } catch (err) { /* malformed blob — leave the card link as fallback */ }
    });
  });
  modal.querySelector('[data-qv-close]').addEventListener('click', close);
  scrim.addEventListener('click', close);
  modal.addEventListener('close', function () { scrim.classList.remove('is-open'); });

  modal.querySelector('[data-qv-prev]').addEventListener('click', function () {
    if (!state.product.images.length) return;
    state.imgIndex = (state.imgIndex - 1 + state.product.images.length) % state.product.images.length;
    renderImage();
  });
  modal.querySelector('[data-qv-next]').addEventListener('click', function () {
    if (!state.product.images.length) return;
    state.imgIndex = (state.imgIndex + 1) % state.product.images.length;
    renderImage();
  });

  opt1El.addEventListener('click', function (e) {
    var opt = e.target.closest('[data-qv-opt1]');
    if (!opt) return;
    state.selected[0] = opt.dataset.qvOpt1;
    opt1El.querySelectorAll('.variant-opt').forEach(function (o) { o.classList.toggle('is-selected', o === opt); });
    updateSubmitState();
  });

  opt2Sel.addEventListener('change', function () {
    state.selected[1] = opt2Sel.value || null;
    updateSubmitState();
  });
})();
